import { render } from "./QuickStart.vue?vue&type=template&id=c0888e14"
import script from "./QuickStart.vue?vue&type=script&lang=js"
export * from "./QuickStart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__